module.exports = __webpack_public_path__ + "img/disableplusicon.4c72d11e.svg";